import React from "react";
import { connect } from "react-redux";
import * as R from "ramda";
import CSSModules from "react-css-modules";
import uuid from "node-uuid";
import { actions } from "../model";
import { getCurrentForm } from "../selectors";
import QuestionaireOptions from "components/Global/Table3/ModalColumn/QuestionaireOptions";
import { noop } from "utils/General";
import css from "./style.scss";

const decorate = R.compose(
  connect(
    (state, props) => {
      const form = getCurrentForm(state, props);
      const defaultSettings = {
        options: [
          {
            id: uuid.v4(),
            value: "",
            isCorrect: false
          }
        ],
        enableMultipleSelect: false,
        allowMultipleSelect: false,
        order: {}
      };
      return {
        editing: R.pathOr(false, ["editing"], state),
        dropdownSettings: R.pathOr(defaultSettings, ["dropdownSettings"], form)
      };
    },
    (dispatch, props) => ({
      setDropdownSettings: settings =>
        dispatch(
          actions.updateSettings({
            index: props.formIndex,
            key: "dropdownSettings",
            settings
          })
        )
    })
  ),
  CSSModules(css)
);

const DropdownSettings = ({
  dropdownSettings,
  setDropdownSettings = noop,
  editing
}) => (
  <div styleName="dropdownOptionsWrapper">
    <QuestionaireOptions
      settings={{
        ...dropdownSettings,
        enableMultipleSelect: !editing || dropdownSettings.enableMultipleSelect,
        options: dropdownSettings.options
      }}
      onChange={setDropdownSettings}
    />
  </div>
);

export default decorate(DropdownSettings);
